// src/components/ModalPagamento.js
import React, { useState } from "react";
import ModalPixCorrida from "./ModalPixCorrida";
import { copyPaymentText } from "../services/paymentActionService";

export default function ModalPagamento({ dados, onFechar }) {
  const [copiado, setCopiado] = useState(false);
  const [showQr, setShowQr] = useState(false);

  if (!dados) return null;

  const handleCopiarPix = async () => {
    if (dados.pixMotorista) {
      try {
        const copied = await copyPaymentText(dados.pixMotorista);
        setCopiado(copied);
        if (copied) setTimeout(() => setCopiado(false), 3000);
      } catch (_) { setCopiado(false); }
    }
  };

  const iconePag = dados.metodo === "pix" ? "📱" : ["maquininha", "cartao_zuno"].includes(dados.metodo) ? "💳" : "💵";

  return (
    <>
      <div style={{
        position: "fixed", inset: 0, zIndex: 99990,
        background: "rgba(0,0,0,0.85)",
        display: "flex", alignItems: "flex-end",
        fontFamily: "'Segoe UI', system-ui, sans-serif",
      }}>
        <style>{`@keyframes slideUp{from{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0)}}`}</style>
        <div style={{
          width: "100%", maxWidth: 480, margin: "0 auto",
          background: "#0d1527",
          borderRadius: "24px 24px 0 0",
          padding: "24px 24px 48px",
          border: "1px solid rgba(34,197,94,0.2)",
          borderBottom: "none",
          animation: "slideUp 0.35s ease",
        }}>
          <div style={{ width: 36, height: 4, background: "rgba(255,255,255,0.15)", borderRadius: 2, margin: "0 auto 20px" }} />

          {/* Título */}
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>✅</div>
            <p style={{ color: "#22c55e", fontWeight: 800, fontSize: 20, margin: "0 0 4px" }}>
              Chegamos! Corrida concluída
            </p>
            <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 13, margin: 0 }}>
              Obrigado por usar a Zuno
            </p>
          </div>

          {/* Valor */}
          <div style={{
            background: "rgba(34,197,94,0.07)",
            border: "1px solid rgba(34,197,94,0.18)",
            borderRadius: 16,
            padding: "20px",
            textAlign: "center",
            marginBottom: 16,
          }}>
            <p style={{ color: "rgba(255,255,255,0.35)", fontSize: 11, letterSpacing: 1, margin: "0 0 6px", textTransform: "uppercase" }}>
              Total a pagar
            </p>
            <p style={{ color: "#22c55e", fontSize: 42, fontWeight: 800, margin: 0, letterSpacing: -2 }}>
              R$ {Number(dados.valor || 0).toFixed(2)}
            </p>
            <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 14, margin: "8px 0 0", fontWeight: 600 }}>
              {iconePag} {dados.labelMetodo}
            </p>
          </div>

          {/* ── PIX: chave + botão QR Code ── */}
          {dados.metodo === "pix" && dados.pixMotorista && (
            <div style={{
              background: "rgba(6,182,212,0.06)",
              border: "1px solid rgba(6,182,212,0.18)",
              borderRadius: 14,
              padding: "14px 16px",
              marginBottom: 12,
            }}>
              <p style={{ color: "rgba(255,255,255,0.35)", fontSize: 10, letterSpacing: 1, margin: "0 0 8px", textTransform: "uppercase" }}>
                Chave Pix do motorista
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                <p style={{ color: "#06b6d4", fontSize: 14, fontWeight: 700, margin: 0, flex: 1, wordBreak: "break-all" }}>
                  {dados.pixMotorista}
                </p>
                <button
                  onClick={handleCopiarPix}
                  style={{
                    padding: "8px 14px", borderRadius: 10,
                    border: "1px solid rgba(6,182,212,0.4)",
                    background: copiado ? "rgba(34,197,94,0.12)" : "rgba(6,182,212,0.08)",
                    color: copiado ? "#22c55e" : "#06b6d4",
                    fontSize: 12, fontWeight: 700, cursor: "pointer",
                    fontFamily: "inherit", flexShrink: 0, transition: "all 0.2s",
                  }}
                >
                  {copiado ? "✓ Copiado" : "Copiar"}
                </button>
              </div>

              {/* Botão abrir QR Code — só aparece se tiver QR Code */}
              {dados.qrCodePix && (
                <button
                  onClick={() => setShowQr(true)}
                  style={{
                    width: "100%", padding: "11px",
                    borderRadius: 10, border: "1px solid rgba(6,182,212,0.35)",
                    background: "rgba(6,182,212,0.08)",
                    color: "#06b6d4", fontSize: 13, fontWeight: 700,
                    cursor: "pointer", fontFamily: "inherit",
                  }}
                >
                  📲 Abrir QR Code para pagar
                </button>
              )}
            </div>
          )}

          {/* Dinheiro: instrução */}
          {dados.metodo === "dinheiro" && (
            <div style={{
              background: "rgba(34,197,94,0.05)",
              border: "1px solid rgba(34,197,94,0.12)",
              borderRadius: 14,
              padding: "14px 16px",
              marginBottom: 16,
              display: "flex", alignItems: "center", gap: 12,
            }}>
              <span style={{ fontSize: 28 }}>💵</span>
              <div>
                <p style={{ color: "#fff", fontWeight: 700, fontSize: 14, margin: "0 0 2px" }}>
                  Entregue R$ {Number(dados.valor || 0).toFixed(2)} em dinheiro
                </p>
                <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 12, margin: 0 }}>
                  Para {dados.motoristaNome?.split(" ")[0] || "o motorista"}
                </p>
              </div>
            </div>
          )}

          <button
            onClick={onFechar}
            style={{
              width: "100%", padding: "15px",
              borderRadius: 14, border: "none",
              background: "linear-gradient(135deg,#7c3aed,#a855f7)",
              color: "#fff", fontSize: 15, fontWeight: 800,
              cursor: "pointer", fontFamily: "inherit",
              boxShadow: "0 4px 20px rgba(124,58,237,0.4)",
            }}
          >
            Confirmar e avaliar motorista ⭐
          </button>
        </div>
      </div>

      {/* QR Code Pix em overlay acima do modal de pagamento */}
      {showQr && (
        <ModalPixCorrida
          chavePix={dados.pixMotorista}
          qrCodeUrl={dados.qrCodePix}
          valorCorrida={dados.valor}
          motoristaNome={dados.motoristaNome}
          onFechar={() => setShowQr(false)}
        />
      )}
    </>
  );
}
